import { extendObservable } from "mobx";
import { IAgrupador } from "./Agrupador";
import { CategoriaMinuta } from "./Categoria";
import { IEtiqueta } from "./Etiquetas";
import { OrigemProcesso } from "./OrigemProcesso";
import { IUsuario } from "./Usuario";
import { FiltroTriagem } from "./Triagem";

export class IFiltroRapido {
    codigo: number;
    nome: string;
    cpf: string;
    gabinete: string;
    liberadoGabinete: boolean;
    dados: IAgrupador[] | string;

    semPrivilegios?: boolean; // TODO remover atributo mutável

    localDoFiltro?: string;
}

export class FiltroEscaninho {
    possuiResponsavel: boolean;
    naoPossuiResponsavel: boolean;
    possuiRedatorDesignado: boolean;
    processoRetornandoAoGabinete: boolean;
    possuiMinutaDespacho: boolean;
    possuiMinutaDecisao: boolean;
    possuiMinutaVoto: boolean;
    possuiMinutaVotoAgravoProvido: boolean;
    naoPossuiMinuta: boolean;
    foraDoGabineteFilter: boolean;
    incluirForaDoGabineteFilter: boolean;
    julgadoFilter: boolean;
    naoJulgadoFilter: boolean;
    tipoJulgamentoPresencialFilter: boolean;
    tipoJulgamentoVirtualFilter: boolean;
    publicavelFilter: boolean;
    naoPublicavelFilter: boolean;
    favoritoFilter: boolean;
    naoFavoritoFilter: boolean;
    votoLiberadoFilter: boolean;
    votoNaoLiberadoFilter: boolean;
    possuiPeticaoPendente: boolean;
    naoPossuiPeticaoPendente: boolean;
    possuiImpedimento: boolean;
    assinavel: boolean;
    orgaoJudicanteSelecionadoFilter: string[];
    andTramTarefasSelecionadoFilter: string[];
    tipoPeticaoSelecionadaFilter: string[];
    motivoImpedimentoSelecionadoFilter: string[];
    tarefaSelecionadaFilter: string[];
    usuarioSelecionadoFilter: string[];
    etiquetaSelecionadaFilter: IEtiqueta[];
    indicadorSelecionadoFilter: string[];
    categoriaProcessoFilter: CategoriaMinuta[];
    situacaoMinutaFilter: string[];
    unidadePublicadoraFilter: string[];
    resultadoJulgamentoFilter: string[];
    listaDeNumeroProcessoFilter: string;
    textoTriagemFilter: string;
    tipoMinutaFilter: string[];
    classeProcessoFilter: string[];
    temaProcessoFilter: string[];
    classeInteiraFilter: string[];
    classeInicialProcessoFilter: string[];
    numeroProcessoFilter: string;
    digitoProcessoFilter: string;
    anoProcessoFilter: string;
    orgaoProcessoFilter: string;
    regionalProcessoFilter: string;
    varaProcessoFilter: string;
    assuntoFilter: string[];
    nomeParteFilter: string;
    parteFilter: string;
    pautaFilter: string[];
    movimentosFilter: string[];
    origem: OrigemProcesso;
    anoAutuacaoFilter: string[];
    situacaoPeticaoFilter: string;
    camposDeTriagemBooleanFilter: FiltroTriagem[];
    camposDeTriagemValorCondenacaoFilter: string;
    camposDeResponsavelPelaTriagemFilter: IUsuario[];
    usuariosUltimaAlteracaoSituacaoMinutaFilter: IUsuario[];
    filtrosFilter: string[];
    relatorProcessoFilter: string[];
    correJuntoFilter: boolean;
    associadoFilter: boolean;

    codigo: number;
    dados: string;
    localDoFiltro: string;
    cpf: string;
    gabinete: string;
    nome: string;

    idFiltroUsado?: number;
    nomeFiltroEscaninho?: string;

    static mobxInicial = () => ({

    })

    static novo(dto: Partial<FiltroEscaninho>): FiltroEscaninho {
        if (!dto) {
            dto = {};
        }
        const filtroEscaninho = new FiltroEscaninho();
        const mobxInicial = FiltroEscaninho.mobxInicial();
        extendObservable(filtroEscaninho, mobxInicial);
        return Object.assign(filtroEscaninho, dto);
    }

    static inicializado(dto: FiltroEscaninho) {
        const dtoStringfy = JSON.parse(JSON.stringify(dto));

        const f = new FiltroEscaninho();
        f.possuiResponsavel = dtoStringfy.possuiResponsavel || false;
        f.naoPossuiResponsavel = dtoStringfy.naoPossuiResponsavel || false;
        f.possuiRedatorDesignado = dtoStringfy.possuiRedatorDesignado || false;
        f.processoRetornandoAoGabinete = dtoStringfy.processoRetornandoAoGabinete || false;
        f.possuiMinutaDespacho = dtoStringfy.possuiMinutaDespacho || false;
        f.possuiMinutaDecisao = dtoStringfy.possuiMinutaDecisao || false;
        f.possuiMinutaVoto = dtoStringfy.possuiMinutaVoto || false;
        f.possuiMinutaVotoAgravoProvido = dtoStringfy.possuiMinutaVotoAgravoProvido || false;
        f.naoPossuiMinuta = dtoStringfy.naoPossuiMinuta || false;
        f.foraDoGabineteFilter = dtoStringfy.foraDoGabineteFilter || false;
        f.incluirForaDoGabineteFilter = dtoStringfy.incluirForaDoGabineteFilter || false;
        f.julgadoFilter = dtoStringfy.julgadoFilter || false;
        f.naoJulgadoFilter = dtoStringfy.naoJulgadoFilter || false;
        f.tipoJulgamentoPresencialFilter = dtoStringfy.tipoJulgamentoPresencialFilter || false;
        f.tipoJulgamentoVirtualFilter = dtoStringfy.tipoJulgamentoVirtualFilter || false;
        f.publicavelFilter = dtoStringfy.publicavelFilter || false;
        f.naoPublicavelFilter = dtoStringfy.naoPublicavelFilter || false;
        f.favoritoFilter = dtoStringfy.favoritoFilter || false;
        f.naoFavoritoFilter = dtoStringfy.naoFavoritoFilter || false;
        f.votoLiberadoFilter = dtoStringfy.votoLiberadoFilter || false;
        f.votoNaoLiberadoFilter = dtoStringfy.votoNaoLiberadoFilter || false;
        f.possuiPeticaoPendente = dtoStringfy.possuiPeticaoPendente || false;
        f.naoPossuiPeticaoPendente = dtoStringfy.naoPossuiPeticaoPendente || false;
        f.possuiImpedimento = dtoStringfy.possuiImpedimento || false;
        f.assinavel = dtoStringfy.assinavel || false;
        f.orgaoJudicanteSelecionadoFilter = dtoStringfy.orgaoJudicanteSelecionadoFilter || [];
        f.andTramTarefasSelecionadoFilter = dtoStringfy.andTramTarefasSelecionadoFilter || [];
        f.tipoPeticaoSelecionadaFilter = dtoStringfy.tipoPeticaoSelecionadaFilter || [];
        f.motivoImpedimentoSelecionadoFilter = dtoStringfy.motivoImpedimentoSelecionadoFilter || [];
        f.tarefaSelecionadaFilter = dtoStringfy.tarefaSelecionadaFilter || [];
        f.usuarioSelecionadoFilter = dtoStringfy.usuarioSelecionadoFilter || [];
        f.etiquetaSelecionadaFilter = dtoStringfy.etiquetaSelecionadaFilter || [];
        f.indicadorSelecionadoFilter = dtoStringfy.indicadorSelecionadoFilter || [];
        f.categoriaProcessoFilter = dtoStringfy.categoriaProcessoFilter || [];
        f.situacaoMinutaFilter = dtoStringfy.situacaoMinutaFilter || [];
        f.unidadePublicadoraFilter = dtoStringfy.unidadePublicadoraFilter || [];
        f.resultadoJulgamentoFilter = dtoStringfy.resultadoJulgamentoFilter || [];
        f.listaDeNumeroProcessoFilter = dtoStringfy.listaDeNumeroProcessoFilter || '';
        f.textoTriagemFilter = dtoStringfy.textoTriagemFilter || '';
        f.tipoMinutaFilter = dtoStringfy.tipoMinutaFilter || [];
        f.classeProcessoFilter = dtoStringfy.classeProcessoFilter || [];
        f.temaProcessoFilter = dtoStringfy.temaProcessoFilter || [];
        f.classeInteiraFilter = dtoStringfy.classeInteiraFilter || [];
        f.classeInicialProcessoFilter = dtoStringfy.classeInicialProcessoFilter || [];
        f.numeroProcessoFilter = dtoStringfy.numeroProcessoFilter || '';
        f.digitoProcessoFilter = dtoStringfy.digitoProcessoFilter || '';
        f.anoProcessoFilter = dtoStringfy.anoProcessoFilter || '';
        f.orgaoProcessoFilter = dtoStringfy.orgaoProcessoFilter || '';
        f.regionalProcessoFilter = dtoStringfy.regionalProcessoFilter || '';
        f.varaProcessoFilter = dtoStringfy.varaProcessoFilter || '';
        f.assuntoFilter = dtoStringfy.assuntoFilter || [];
        f.nomeParteFilter = dtoStringfy.nomeParteFilter || '';
        f.parteFilter = dtoStringfy.parteFilter || '';
        f.pautaFilter = dtoStringfy.pautaFilter || [];
        f.movimentosFilter = dtoStringfy.movimentosFilter || [];
        f.origem = dtoStringfy.origem || undefined;
        f.anoAutuacaoFilter = dtoStringfy.anoAutuacaoFilter || [];
        f.situacaoPeticaoFilter = dtoStringfy.situacaoPeticaoFilter || '';
        f.camposDeTriagemBooleanFilter = dtoStringfy.camposDeTriagemBooleanFilter || [];
        f.camposDeTriagemValorCondenacaoFilter = dtoStringfy.camposDeTriagemValorCondenacaoFilter || '';
        f.camposDeResponsavelPelaTriagemFilter = dtoStringfy.camposDeResponsavelPelaTriagemFilter || [];
        f.usuariosUltimaAlteracaoSituacaoMinutaFilter = dtoStringfy.usuariosUltimaAlteracaoSituacaoMinutaFilter || [];
        f.filtrosFilter = dtoStringfy.filtrosFilter || [];
        f.relatorProcessoFilter = dtoStringfy.relatorProcessoFilter || [];
        f.correJuntoFilter = dtoStringfy.correJuntoFilter || false;
        f.associadoFilter = dtoStringfy.associadoFilter || false;

        f.codigo = dtoStringfy.codigo || dtoStringfy.idFiltroUsado || undefined;
        f.dados = dtoStringfy.dados || '';
        f.localDoFiltro = dtoStringfy.localDoFiltro || '';
        f.cpf = dtoStringfy.cpf || '';
        f.gabinete = dtoStringfy.gabinete || '';
        f.nome = dtoStringfy.nome || '';

        return f;
    }

    public toJSON() {

        return {
            ...this,
            nomeStore: undefined,
            drawerIsOpen: undefined,
            modalSalvarFiltroAberto: undefined,
            modalUsarFiltroAberto: undefined,
            filtroAplicado: undefined,
            filtrosEscaninho: undefined,
        };
    }
}
